import { TooltipWrapper } from 'components/TooltipWrapper';
import { IconAlert } from 'uikit';

import type { IHeaderParams } from 'ag-grid-community';

interface IPassageHeaderComponent extends IHeaderParams {
    hasEmptyWorkRatios: boolean;
}

export const PassageHeaderComponent = (props: IPassageHeaderComponent) => {
    const { displayName, hasEmptyWorkRatios } = props;

    return hasEmptyWorkRatios ? (
        <TooltipWrapper toolTipClassName="toolTipWidth" message="Имеются незаполненые обязательные поля">
            <IconAlert size="s" view="alert" />
            <span style={{ marginLeft: 5 }}>{displayName}</span>
        </TooltipWrapper>
    ) : (
        displayName
    );
};

PassageHeaderComponent.displayName = 'PassageHeaderComponent';
